'use strict';

const extractSequence = function (envelope) {
		return (envelope && envelope.header && envelope.header.sequence) || 0;
	},
	extractSession = function (envelope) {
		return (envelope && envelope.header && envelope.header.sessionId) || '';
	},
	SequenceAwareArray = function (envelopeArray) {
		let sequenceBySession = {};
		const self = this,
			outOfOrder = function (envelope) {
				const session = extractSession(envelope),
					sequence = extractSequence(envelope),
					previous = sequenceBySession[session];
				if (previous && previous > sequence) {
					return true;
				}
				sequenceBySession[session] = sequence;
				return false;
			};
		self.containsOutOfOrderElement = function () {
			sequenceBySession = {};
			return envelopeArray && envelopeArray.find(outOfOrder);
		};
		self.outOfOrderElements = function () {
			sequenceBySession = {};
			return envelopeArray && envelopeArray.filter(outOfOrder);
		};
	},
	compareSequences = function (envelope1, envelope2) {
		return extractSequence(envelope1) - extractSequence(envelope2);
	},
	sortBySession = function (envelopeArray) {
		const result = {};
		if (!envelopeArray || !envelopeArray.length) {
			return result;
		}
		envelopeArray.forEach(envelope => {
			const session = extractSession(envelope);
			if (!result[session]) {
				result[session] = [];
			}
			result[session].push(envelope);
		});
		Object.values(result).forEach(subArray => subArray.sort(compareSequences));
		return result;
	};
module.exports = function GoldFileHistoryEnvelopeSorter() {
	const self = this;
	self.requiresSorting = function (envelopeArray) {
		return new SequenceAwareArray(envelopeArray).containsOutOfOrderElement();
	};
	self.sortedEnvelopes = function (envelopeArray) {
		const result = [],
			outOfOrderElements = new SequenceAwareArray(envelopeArray).outOfOrderElements(),
			outOfOrderBySession = sortBySession(outOfOrderElements);
		envelopeArray.filter(envelope => !outOfOrderElements.includes(envelope)).forEach(envelope => {
			const session = extractSession(envelope),
				sequence = extractSequence(envelope),
				candidates = outOfOrderBySession[session],
				remaining = [];
			if (!candidates || candidates.length === 0) {
				result.push(envelope);
				return;
			}
			if (extractSequence(candidates[0]) > sequence) {
				result.push(envelope);
				return;
			}
			candidates.forEach(candidate => {
				const candidateSequence = extractSequence(candidate);
				if (candidateSequence <= sequence) { //TODO: perhaps eliminate dupes here?
					result.push(candidate);
				} else {
					remaining.push(candidate);
				}
			});
			result.push(envelope);
			if (remaining.length) {
				outOfOrderBySession[session] = remaining;
			} else {
				outOfOrderBySession[session] = false;
			}
		});
		return result;
	};
};
